import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo/logo.jpg';
import { useSettings } from '../context/SettingsContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { settings } = useSettings();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <style>{`@media (max-width:768px){.hamburger-line{background:#FFD700!important;background-color:#FFD700!important}}`}</style>
      <nav>
        <div className="nav-container">
          {/* Logo - LEFT */}
          <Link to="/" className="logo">
            <img 
              src={settings?.logo_url || logoImage} 
              alt={settings?.site_name || 'FACTO ELECTRONICAL'} 
              className="logo-image"
            />
          </Link>

          {/* Desktop Navigation - CENTER */}
          <ul className="nav-menu">
            <li>
              <Link to="/">HOME</Link>
            </li>
            
            <li>
              <Link to="/products">PRODUCTS</Link>
            </li>
            
            <li>
              <Link to="/media">MEDIA</Link>
            </li>
            <li>
              <Link to="/about">ABOUT</Link>
            </li>
            <li>
              <Link to="/contact">CONTACT</Link>
            </li>
          </ul>

          {/* Right Section removed */}

          {/* Mobile Menu Toggle */}
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-content">
            <Link to="/" onClick={toggleMobileMenu}>HOME</Link>
            <Link to="/products" onClick={toggleMobileMenu}>PRODUCTS</Link>
            <Link to="/media" onClick={toggleMobileMenu}>MEDIA</Link>
            <Link to="/about" onClick={toggleMobileMenu}>ABOUT</Link>
            <Link to="/contact" onClick={toggleMobileMenu}>CONTACT</Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
